<template>
  <div>
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <Birthday />
    <Appointments />
  </div>
</template>

<script>
// @ is an alias to /src
import Birthday from "@/components/Birthday.vue";
import Appointments from "@/components/Appointments.vue";
import { mapActions } from "vuex";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
import { canVerb } from "@/utils/permissions";

export default {
  mixins: [StorageGetterMixin],
  name: "Home",
  components: {
    Appointments,
    Birthday,
  },
  methods: {
    canVerb,
    ...mapActions("queue", ["notifyQueue"]),
  },
  created() {
    this.notifyQueue({ text: "Home", path: "module.HOME", level: 0 });
    // console.log(`%c CREATED HOMEPAGE`, "color: orange");
    /* */
    const path = "auth/";
    const resources = [];
    if (this.canVerb("reports", "index") && !this.hasLoadedResource("reports"))
      resources.push(
        this.$store
          .dispatch(`${path}reports`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          })
      );
    if (!this.hasLoadedResource("users"))
      resources.push(
        this.$store
          .dispatch(`${path}users`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          })
      );
    if (!this.hasLoadedResource("insurers"))
      resources.push(
        this.$store
          .dispatch(`${path}insurers`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          })
      );
    if (!this.hasLoadedResource("conti_prima_nota"))
      resources.push(
        this.$store
          .dispatch(`${path}conti_prima_nota`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          })
      );
    if (resources.length) {
      this.getResources(resources)
        .then(() => {})
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
    }
    /* */
  },
};
</script>
<style scoped>
.home {
  text-align: center;
}
</style>
